module.exports = __webpack_public_path__ + "src/app/header/no-avatar.png?9b1c276a46d3c1ef9a07a35d0ebfbf78";